<template>
  <div class="leadlist-step-2">
    <form-group
      v-model="form.name"
      select
      remote
      id="name"
      filterable
      disableAutocomplete
      placeholder="Selecionar..."
      label="Tag do ActiveCampaign"
      :errors="errors.name"
      :loading="loadingFetch"
      :options="[...tagOptions]"
      :remote-method="fetchActiveCampaign"
    />

    <action-dispatcher
      :parameters="{ product_id }"
      :action="isSignature ? 'plan/get' : 'offer/get'"
    >
      <form-group
        v-if="isSignature"
        v-model="form.plan_id"
        select
        nullable
        id="offer-select"
        label="Plano (opcional)"
        placeholder="Selecionar..."
        :options="plans"
        :errors="errors.plan_id"
      />
      <form-group
        v-else
        v-model="form.offer"
        select
        nullable
        id="offer-select"
        label="Oferta (opcional)"
        placeholder="Selecionar..."
        :options="offers"
        :errors="errors.offer"
      />
    </action-dispatcher>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loadingFetch: false,
      params: {
        provider_id: get(this, "provider.id", ""),
        search: ""
      }
    };
  },
  props: {
    product_id: {
      type: [Number, String],
      default: null
    },
    provider: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("integration", ["providers", "mapProviderName", "tags"]),
    ...mapState("product", ["products"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    providerOptions() {
      return this.providers.map(p => ({
        ...p,
        name: `${this.mapProviderName[p.name]} - ${p.description}`
      }));
    },
    tagOptions() {
      return get(this.tags, "tags", []).map(t => {
        return { id: t.tag, name: t.tag };
      });
    },
    isSignature() {
      return get(this.product, "type_product") === "signature";
    }
  },
  mounted() {
    this.fetchActiveCampaign("");
  },
  methods: {
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getProviders", { limit: 500 })
        .then()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível carregar os provedores");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchActiveCampaign(search) {
      this.params.search = search;
      this.loadingFetch = true;

      this.$store
        .dispatch("integration/getActiveCampaignTags", this.params)
        .finally(() => {
          this.loadingFetch = false;
        });
    }
  }
};
</script>
